import { lazy } from 'react';

const Modal = lazy(() => import('./Modal'));

export { Modal };
